import { ChakraFlex, CircularProgress } from '@equip.health/ui';

type Props = {
  testId?: string;
};
const Loading = ({ testId }: Props) => (
  <ChakraFlex
    alignItems="center"
    data-testid={testId}
    height="100%"
    justifyContent="center"
  >
    <CircularProgress id="page-content" isIndeterminate />
  </ChakraFlex>
);

export default Loading;
